import React, { useEffect, useState } from 'react';
import withNotification from '../../../hoc/withNotification';
//import io from 'socket.io-client';

const TaskNotifications = () => {
    const [socket, setSocket] = useState(null);
    const [granted, setGranted] = useState(false)

    // useEffect(() => {
    //     const eventData = {
    //         title: 'sample',
    //         timeBefore: 15,
    //         description: 'sample description',
    //         id: 78,
    //         url: 'http://localhost:3002/ui/task'
    //     }
    //     if (granted && 'Notification' in window && Notification.permission === 'granted') {
    //         navigator.serviceWorker.ready.then(registration => {
    //             registration.showNotification(eventData.title, {
    //                 body: `Event starts in ${eventData.timeBefore} minutes: ${eventData.description}`,
    //                 icon: '/event-icon.png',
    //                 tag: eventData.id,  // Ensures unique notifications
    //                 data: {
    //                     url: eventData.url  // URL to open when notification is clicked
    //                 }
    //             });
    //         });
    //         // Listen for events from the socket
    //         // socket.on('eventNotification', (eventData) => {
    //         //     console.log('Event Notification received:', eventData);

    //         //     // Show a notification via the service worker
    //         //     navigator.serviceWorker.ready.then(registration => {
    //         //         registration.showNotification(eventData.title, {
    //         //             body: `Event starts in ${eventData.timeBefore} minutes: ${eventData.description}`,
    //         //             icon: '/event-icon.png',
    //         //             tag: eventData.id,  // Ensures unique notifications
    //         //             data: {
    //         //                 url: eventData.url  // URL to open when notification is clicked
    //         //             }
    //         //         });
    //         //     });
    //         // });
    //     }
    // }, [granted]);

    return <div>Notifications Enabled!</div>;
};

export default withNotification(TaskNotifications);
